// extracted by mini-css-extract-plugin
export default {"actions":"actions__IFn5H","btn":"btn__oTQXI","secondary":"secondary__BTNiS","icon-post":"icon-post__vh3hb"};